{
  class MultiPhotosController {
    constructor($rootScope, $scope, ngDialog, Logger, Media, Notifications, Orders) {
      'ngInject';

      Object.assign(this, {
        $rootScope,
        ngDialog,
        Logger,
        Media,
        Notifications,
        Orders
      });
      $scope.$on('tab:selected:photos', () => this.init());
      $scope.$on('visit:loaded', () => this.init());
    }
    $onInit() {
      this.init();
    }
    init() {
      this.loading = true;
      // TODO: #statusMapping
      this.isUserDeleted = this.visit.user.status === 2;
      if (this.visit.needsDiagnosis()) {
        this.needsDiagnosis = true;
        this.Media.getLabels(this.visit).then(({
          data
        }) => this.labels = data);
      } else {
        this.needsDiagnosis = false;
      }
      this.Orders.getPhotos().then(({
        data
      }) => {
        let {
          photos,
          diagnosis
        } = data;
        Object.assign(this, {
          error: null,
          errorMessage: null,
          rejectionMessage: null,
          waitingForUpload: null,
          isApproved: null,
          photos,
          diagnosis,
          task: this.visit.getTask(this.Orders.TASKS.MULTI_PHOTO)
        });
        switch (this.task.status) {
          case this.Orders.STATUS.APPROVED:
            this.isApproved = true;
            break;
          case this.Orders.STATUS.REJECTED:
            this.waitingForUpload = true;
        }
      }).catch(err => this.error = err.status === 404 ? 'No Photos Uploaded' : 'Error Downloading Photos').finally(() => this.loading = false);
    }
    approve() {
      const payload = {
        approved: true
      };

      // Check to see whether this service requires a legitimate diagnosis
      if (this.visit.needsDiagnosis()) {
        // If it does, check whether or not a diagosis has been selected
        if (this.selectedDiagnosis) {
          payload.diagnosis = this.selectedDiagnosis.diagnosis;
        } else {
          // Error and exit if no diagnosis selected
          this.errorMessage = 'Please select a diagnosis';
          return;
        }
      } else {
        // Just attach our current service as diagnosis if one is not necessary
        payload.diagnosis = this.visit.service.code;
      }
      this.updatePhotoTask(payload);
    }
    reject() {
      if (!this.rejectionMessage || !this.rejectionMessage.trim()) {
        this.errorMessage = 'Please provide a rejection message';
        return;
      }
      const payload = {
        approved: false,
        rejection_message: this.rejectionMessage,
        photo_ids: _.map(_.filter(this.photos, f => f.rejected), f => f.id),
        diagnosis: this.visit.service.code
      };
      this.updatePhotoTask(payload);
    }
    updatePhotoTask(payload) {
      this.Orders.setPhotos(this.visit.id, payload).then(() => {
        // Set task status based on approval or rejection
        this.task.status = payload.approved ? this.Orders.STATUS.APPROVED : this.Orders.STATUS.REJECTED;
        this.visit.admin_status = payload.approved ? 5.4 : 5.5;
        Object.assign(this, {
          diagnosis: payload.diagnosis,
          isApproved: payload.approved,
          waitingForUpload: !payload.approved,
          errorMessage: null,
          rejectionMessage: null
        });
        this.$rootScope.$broadcast('photos:updated', payload.approved);
        this.$rootScope.$broadcast('visit:refresh');
      }).catch(err => {
        if (err.data.status == 403) {
          this.errorMessage = this.Notifications.orders.locked;
        } else if (err.data.message && err.data.message.summary) {
          this.errorMessage = err.data.message.summary;
        } else {
          this.errorMessage = this.Notifications.orders.photos.failed;
        }
      });
    }
    openPhotoGallery(index = 0) {
      this.ngDialog.open({
        templateUrl: 'app/components/gallery/gallery.html',
        className: 'ngdialog-theme-default photo-dialog',
        controller: 'GalleryController',
        controllerAs: 'gallery',
        resolve: {
          files: () => this.photos,
          data: () => {
            return {
              index,
              requiresAction: this.requiresAction.bind(this)
            };
          }
        }
      });
    }
    openDiagnosisReference() {
      this.ngDialog.open({
        templateUrl: 'app/views/visits/detail/sections/photos/photos.diagnosis.html',
        className: 'ngdialog-theme-default diagnosis-dialog',
        controllerAs: 'diagnosis',
        data: {
          image: `assets/images/${this.visit.service.code === 'HL' ? 'norwood_reference.gif' : 'acne_reference.png'}`
        }
      });
    }
    hasRejected() {
      return !!_.find(this.photos, {
        rejected: true
      });
    }
    requiresAction() {
      return this.visit.isPending() && !this.isApproved && !this.waitingForUpload;
    }
  }
  MultiPhotosController.$inject = ["$rootScope", "$scope", "ngDialog", "Logger", "Media", "Notifications", "Orders"];
  angular.module('pims').component('multiPhotos', {
    templateUrl: 'app/views/visits/detail/sections/photos/multi/multiPhotos.html',
    controller: MultiPhotosController,
    bindings: {
      visit: '='
    }
  });
}